var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default"),_c('popup-notification',{ref:"notification",on:{"send-report":_vm.sendReports}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }